export const paginationComponentOptions = {
  rowsPerPageText: "ჩანაწერები გვერდზე:",
  rangeSeparatorText: "დან",
  selectAllRowsItem: true,
  selectAllRowsItemText: "ყველა ჩანაწერი",
};
